import { formateazaRON } from "@/lib/settlement";

// Cardul de rezumat (total cheltuit + soldul tău sau nr. de transferuri rămase).
export function GroupSummaryCard({ total, meMember, soldMeu, decontariCount }) {
  return (
    <div
      data-testid="group-summary"
      className="rounded-2xl brand-bg text-white p-4 flex items-center justify-between"
    >
      <div>
        <p className="text-xs text-white/80">Total cheltuit</p>
        <p className="font-heading text-2xl font-black">{formateazaRON(total)}</p>
      </div>
      <div className="text-right">
        {meMember ? (
          <>
            <p className="text-xs text-white/80">Soldul tău</p>
            <p data-testid="my-balance" className="font-heading text-lg font-black">
              {soldMeu > 0.01
                ? `ești pe plus cu ${formateazaRON(soldMeu)}`
                : soldMeu < -0.01
                ? `ești pe minus cu ${formateazaRON(-soldMeu)}`
                : "ești chit"}
            </p>
          </>
        ) : (
          <>
            <p className="text-xs text-white/80">Decontare</p>
            <p className="font-heading text-sm font-bold">
              {decontariCount === 0
                ? "Toți sunteți chit"
                : `${decontariCount} ${decontariCount === 1 ? "transfer" : "transferuri"} de făcut`}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
